import { createI18n } from 'vue-i18n';
import en from './locales/en.js'
import fr from './locales/fr.js'
import nl from './locales/nl.js'
import de from './locales/de.js'


export const i18n = createI18n({
    legacy: false,
    locale: 'en',
    fallbackLocale: 'en',
    messages: {
        en,
        fr,
        nl,
        de
    }
})
